/**
* Two Image Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Two Image Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'two-image-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth >= 1024 ) {
        // Create a master ScrollTrigger for both parallax effects
        $( '.two-image-cards' ).each( function() {
          ScrollTrigger.create( {
            trigger: '.two-image-cards',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            onUpdate: ( self ) => {
              // Get the scroll progress (range from 0 to 1)
              const progress = self.progress;

              // Apply the parallax effect for .parallax-up elements
              $( this ).find( '.parallax-up' ).each( function() {
                const yOffset = -80 * progress; // Moves up with scroll
                gsap.set( $( this ), {y: `${yOffset}px`} );
              } );

              // Apply the parallax effect for .parallax-down elements
              $( this ).find( '.parallax-down' ).each( function() {
                const yOffset = 80 * progress; // Moves down with scroll
                gsap.set( $( this ), {y: `${yOffset}px`} );
              } );
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'two-image-cards', COMPONENT );
} )( app );
